import { render } from "./StonesFormStep0.vue?vue&type=template&id=3180e034&scoped=true&lang=html"
import script from "./StonesFormStep0.vue?vue&type=script&lang=js"
export * from "./StonesFormStep0.vue?vue&type=script&lang=js"

import "./StonesFormStep0.vue?vue&type=style&index=0&id=3180e034&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3180e034"]])

export default __exports__